module.exports = __webpack_public_path__ + "static/assets/550341ce9dd15d9b959cc87fee32679f.png";